import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { CapitalizeFirstLetter } from '@cdab/headless-components'
import { TdsBadge, TdsInlineTab, TdsInlineTabs } from '@scania/tegel-react'

import { LinkTab } from '@cdab/scania/qpr/components/atoms'
import type { TdsInlineTabsCustomEvent } from '@scania/tegel'
import type { AuditPageTabsProps } from './audit-page-tabs.types'

export function AuditPageTabs(props: AuditPageTabsProps) {
  const { t } = useTranslation()
  const location = useLocation()

  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  const tabRoutes = [
    props.links.summary,
    props.links.points,
    props.links.deviations
  ]

  useEffect(() => {
    const currentIndex = tabRoutes.findIndex(
      route => location.pathname.includes(route) || location.pathname === route
    )
    if (currentIndex !== -1) {
      setSelectedTabIndex(currentIndex)
    }
  }, [location.pathname])

  const handleTabChange = (
    e: TdsInlineTabsCustomEvent<{
      selectedTabIndex: number
    }>
  ) => {
    const newIndex = e.detail.selectedTabIndex
    setSelectedTabIndex(newIndex)
  }

  return (
    <TdsInlineTabs
      modeVariant='primary'
      selectedIndex={selectedTabIndex}
      onTdsChange={handleTabChange}
    >
      <TdsInlineTab>
        <LinkTab to={props.links.summary}>
          <CapitalizeFirstLetter>{t('summary')}</CapitalizeFirstLetter>
        </LinkTab>
      </TdsInlineTab>

      {props.isDos5 && (
        <TdsInlineTab>
          <LinkTab to={props.links.points}>
            <CapitalizeFirstLetter>{t('audit-points')}</CapitalizeFirstLetter>
          </LinkTab>
        </TdsInlineTab>
      )}

      <TdsInlineTab>
        <LinkTab to={props.links.deviations}>
          <CapitalizeFirstLetter>{t('deviations')}</CapitalizeFirstLetter>
          <TdsBadge value={props.numberOfDeviations.toString()} size='lg' />
        </LinkTab>
      </TdsInlineTab>
    </TdsInlineTabs>
  )
}
